import { Text, Flex, Icon, Stack } from '@pairy/pds-react';
import React, { useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';
import Image from 'next/image';

import ProPlanUpgradeModal from '@/components/User/_components/common/ProPlanUpgradeModal';
import { userInfoAtom } from '@/state/user/atom';

import * as Styled from './index.styles';

const ProPlanUpgradeBanner = () => {
  const [isOpen, setIsOpen] = useState(false);

  const userInfo = useAtomValue(userInfoAtom);

  const upSellBannerList = [
    <Styled.UpdateWrapper
      key={'first'}
      direction="column"
      justifyContent="flex-end"
      padding={32}
    >
      <Styled.UpdateImageWrapper>
        <Image
          src="/images/banner/basic-upgrade.png"
          width={349}
          height={284}
        />
      </Styled.UpdateImageWrapper>
      <Styled.TextWrapper>
        <Text variant="xl-semibold" marginBottom={16}>
          세일즈클루 링크는 그대로,
          <br />
          자료를 새롭게 업데이트 해보세요
        </Text>
        <Flex as="button" alignItems="center" onClick={() => setIsOpen(true)}>
          <Text variant="lg-medium" marginRight={8}>
            Basic Plan으로 업그레이드
          </Text>
          <Icon icon="ph:caret-right" size={18} color="black" />
        </Flex>
      </Styled.TextWrapper>
    </Styled.UpdateWrapper>,
    <Styled.VersionWrapper
      key={'second'}
      direction="column"
      justifyContent="flex-end"
      padding={32}
    >
      <Styled.VersionImageWrapper>
        <Image
          src="/images/banner/version-banner.png"
          width={350}
          height={204}
        />
      </Styled.VersionImageWrapper>
      <div>
        <Stack gap={8} direction="column">
          <Text variant="sm-medium" color="zinc_500">
            어떤 순서로 자료를 만들어야 더 효과적일까요?
          </Text>
          <Text variant="xl-semibold" marginBottom={16} color="zinc_900">
            여러 버전으로 테스트 해보세요
          </Text>
        </Stack>
        <Flex as="button" alignItems="center" onClick={() => setIsOpen(true)}>
          <Text variant="lg-medium" marginRight={8} color="zinc_900">
            Pro Plan으로 업그레이드
          </Text>
          <Icon icon="ph:caret-right" size={18} color="zinc_900" />
        </Flex>
      </div>
    </Styled.VersionWrapper>,
    <Styled.CtaWrapper
      key="third"
      direction="column"
      justifyContent="flex-end"
      padding={32}
    >
      <Styled.CtaImageWrapper>
        <Image src="/images/banner/cta-banner.png" width={349} height={215} />
      </Styled.CtaImageWrapper>
      <div>
        <Text variant="xl-semibold" marginBottom={16}>
          PDF 자료에 바로
          <br />
          문의 양식이나 버튼을 더해보세요
        </Text>
        <Flex as="button" alignItems="center" onClick={() => setIsOpen(true)}>
          <Text variant="lg-medium" marginRight={8}>
            Pro Plan으로 업그레이드
          </Text>
          <Icon icon="ph:caret-right" size={18} color="black" />
        </Flex>
      </div>
    </Styled.CtaWrapper>,
  ];

  const RandomBanner = useMemo(() => {
    if (userInfo?.subscriptionPlan?.name === 'Free') {
      const random = Math.floor(Math.random() * upSellBannerList.length);
      return upSellBannerList[random];
    }
    if (userInfo?.subscriptionPlan?.name === 'Basic') {
      const random = Math.random() < 0.5 ? 1 : 2;
      return upSellBannerList[random];
    }
    return null;
  }, [userInfo]);

  return (
    <>
      {userInfo?.subscriptionPlan?.name === 'Free' ||
      userInfo?.subscriptionPlan?.name === 'Basic'
        ? RandomBanner
        : null}
      {isOpen && (
        <ProPlanUpgradeModal
          onOpenChange={(open: boolean) => {
            setIsOpen(open);
          }}
        />
      )}
    </>
  );
};

export default React.memo(ProPlanUpgradeBanner);
